export enum StoreKey {
	APP = 'app',
	CART = 'cart',
	USER_VOUCHER = 'userVoucher',
}
